

module.exports = __webpack_require__.stylable.create(
    "Badge1738959690",
    {"classes":{"root":"Badge1738959690__root","prefix":"Badge1738959690__prefix","suffix":"Badge1738959690__suffix","BadgeStyle":"Badge1738959690__BadgeStyle","text":"Badge1738959690__text"},"vars":{},"stVars":{"backgroundColor":"grey","borderColor":"grey","color":"#FFFFFF","padding":"5px 12px","medium":"0px 12px","small":"0px 6px","tiny":"0px 5.5px","mediumHeight":"24px","smallHeight":"18px","tinyHeight":"18px"},"keyframes":{}},
    "",
    6,
    "Badge1738959690",
    null
);
